import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Chip,
  IconButton,
  Container,
  Typography,
  TableContainer,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "../MoComponent.css";
import Header from "../../Header/Header";
import BookAppointmentModal from "../BookAppointmentModal/BookAppointmentModal";
import CreateSlotModal from "../CreateSlotModal/CreateSlotModal";
import Createsloticon from "../../Images/Createslots.svg";
import Bookappoinicon from "../../Images/ic_twotone-plus.svg";
import { CommonContext } from "../../../context/CommonContext";
import { authHttp } from "../../../services/commonHttpService";
import { apisPath } from "../../../utils/path";
import { formatDate, formatSlotTime } from "../../../helpers/commonHelper";

const AppointmentManagement = () => {
  const { setIsLoading, setSnackState } = useContext(CommonContext);

  const [slots, setSlots] = useState([]);
  const [openBookModal, setOpenBookModal] = useState(false);
  const [openSlotModal, setOpenSlotModal] = useState(false);

  // Fetch all slots
  const fetchSlots = async () => {
    setIsLoading(true);
    try {
      const response = await authHttp.get(apisPath?.getAllSlots);

      if (response?.data?.status) {
        setSlots(response?.data?.data);
      }
    } catch (error) {
      setSnackState((prev) => ({
        ...prev,
        open: true,
        message: error?.response?.data?.message || "Failed to fetch slots",
        severity: "error",
      }));
      setSlots([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch slots on component mount
  useEffect(() => {
    fetchSlots();
  }, []);

  // Handle successful slot creation
  const handleSlotCreated = () => {
    setOpenSlotModal(false);
    fetchSlots(); // Refresh slots list
  };

  const getStatusChip = (status) => {
    let colorClass = "";
    switch (status) {
      case "Completed":
        colorClass = "chip-completed";
        break;
      case "Scheduled":
        colorClass = "chip-scheduled";
        break;
      case "Ongoing":
        colorClass = "chip-ongoing";
        break;
      case "Cancelled":
        colorClass = "chip-cancelled";
        break;
      default:
        colorClass = "";
    }
    return <Chip label={status} className={`custom-chip ${colorClass}`} />;
  };

  // Get availability status for slot
  const getAvailabilityStatus = (availableBeds, totalBeds) => {
    if (availableBeds === 0) return "Full";
    if (availableBeds === totalBeds) return "Available";
    return "Partially Booked";
  };

  // Get chip color for availability
  const getAvailabilityChip = (availableBeds, totalBeds) => {
    const status = getAvailabilityStatus(availableBeds, totalBeds);
    let colorClass = "";

    switch (status) {
      case "Available":
        colorClass = "chip-scheduled"; // Green
        break;
      case "Partially Booked":
        colorClass = "chip-ongoing"; // Orange/Yellow
        break;
      case "Full":
        colorClass = "chip-cancelled"; // Red
        break;
      default:
        colorClass = "";
    }

    return <Chip label={status} className={`custom-chip ${colorClass}`} />;
  };

  return (
    <>
      <Header showFullHeader={false} />
      <div className="formobileclass">
      <Container className="contain-top">
        <div className="">
          {/* Header Section */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4 className="title-text">Appointment Management</h4>
            <div className="margin-container d-flex">
              <Button
                variant="contained"
                className="btn-custom me-2"
                onClick={() => setOpenSlotModal(true)}
              >
                <span>
                  <img src={Createsloticon} alt="" className="icon-slots" />
                </span>
                Create Slot
              </Button>
              <div>
                <BookAppointmentModal
                  open={openBookModal}
                  onClose={() => setOpenBookModal(false)}
                  onSubmit={() => {
                    // console.log("Booking Submitted");
                    setOpenBookModal(false);
                  }}
                />
                {/* Create Slot Modal */}
                <CreateSlotModal
                  open={openSlotModal}
                  onClose={() => setOpenSlotModal(false)}
                  onSuccess={handleSlotCreated} // Add this line
                />
              </div>
            </div>
          </div>

          <div className="row">
            {/* Left - Appointment Table */}
            <div className="col-md-12">
              <div className="card-custom p-3 mt-3">
                <TableContainer>
                  <Table sx={{ minWidth: 900 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>Slot ID</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Time Slot</TableCell>
                        <TableCell>Total Beds</TableCell>
                        <TableCell>Available Beds</TableCell>
                        <TableCell>Booked</TableCell>
                        <TableCell>Status</TableCell>
                        {/* <TableCell>Action</TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {slots.length > 0 ? (
                        slots.map((slot) => (
                          <TableRow key={slot?.slot_id}>
                            <TableCell>S-{slot?.slot_id}</TableCell>
                            <TableCell>{formatDate(slot?.date)}</TableCell>
                            <TableCell>
                              {formatSlotTime(slot?.start_time, slot?.end_time)}
                            </TableCell>
                            <TableCell>{slot?.total_beds}</TableCell>
                            <TableCell>{slot?.available_beds}</TableCell>
                            <TableCell>
                              {slot?.total_beds - slot?.available_beds}
                            </TableCell>
                            <TableCell>
                              {getAvailabilityChip(
                                slot?.available_beds,
                                slot?.total_beds
                              )}
                            </TableCell>
                            {/* <TableCell>
                            <IconButton>
                              <VisibilityIcon />
                            </IconButton>
                          </TableCell> */}
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan="8" className="text-center p-4">
                            <Typography variant="body2" color="text.secondary">
                              No slots available
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </div>
          </div>
        </div>
      </Container>
      </div>
    </>
  );
};

export default AppointmentManagement;
